import type { UserRole } from "@/types/auth";

export function hasRequiredRole(userRole: UserRole | UserRole[], requiredRole?: UserRole, requiredRoles?: UserRole[]) {
  const userRoles = Array.isArray(userRole) ? userRole : [userRole];

  if (userRoles.includes("super")) {
    return true;
  }

  if (requiredRoles && requiredRoles.length > 0) {
    return userRoles.some((role) => requiredRoles.includes(role));
  }

  if (requiredRole) {
    return userRoles.includes(requiredRole);
  }

  return true;
}
